@if (isBanner) {
  @if (showBannerPages) {
    @if (closeBanner) {
      <section
        @slideInFromBottom
        @stickyAnimation
        [@bannerResize]="bannerState"
        [class.is-not-collapsed]="isNotCollapsed"
        [class.is-sticky]="isSticky"
        class="bottom-banner"
      >
        <div [class]="isSticky ? 'custom-row' : ''" nz-row
        >
          @if (isSticky) {
            <div
              nz-col
              [nzMd]="14"
              [nzXs]="24"
            >
              @if (!isMobile) {
                <!-- DESKTOP -->
                <div [class]="isNotCollapsed ? 'pd' : 'top-position'" class="banner-inner">
                  @if (isNotCollapsed) {
                    <p class="banner-inner-title">{{ bannerData.title }}</p>
                  }
                  <p
                    [class]="!isNotCollapsed ? 'banner-subtitle' : ''"
                    [innerHTML]="bannerData.description"
                    [style.font-size.px]="isNotCollapsed ? '24' : '18'"
                    class="banner-inner-subtitle"
                  ></p>
                  @if (isNotCollapsed) {
                    <a
                      [href]="bannerData.cta.collegamento"
                      class="banner-inner-btn"
                    >
                      {{ bannerData.cta.etichetta }}
                    </a>
                  }
                </div>
              } @else {
                <!-- MOBILE -->
                <div
                  nz-col
                  [class]="isNotCollapsed ? 'pd' : !isSticky ? '' : ''"
                  class=""
                  [nzMd]="10"
                  [nzXs]="24">
                  <div [class]="isNotCollapsed
                       ? 'd-flex align-items-center justify-content-center'
                       : isMobile ? '' : ''"
                    [style.margin-top.px]="!isNotCollapsed ? '0' : '10'"
                  >
                    @if (isNotCollapsed) {
                      @if (isMobile) {
                        <div class="banner-row">
                          <!-- LOGHI -->
                          <div class="banner-logos">
                            <img
                              [src]="bannerData.logo_old"
                              [style.width.px]="isMobile ? 50 : 58"
                              alt="Logo"
                              class="logo-old"
                            />
                            <img
                              alt="Freccia a destra"
                              class="arrow"
                              src="/public/assets/images/arrow-right-banner.svg"
                            />
                            <img
                              [src]="bannerData.logo_new"
                              [style.width.px]="isMobile ? 148 : 204"
                              alt="Logo"
                              class="logo-new"
                            />
                          </div>
                          <!-- CLOSE -->
                          <img
                            (click)="handleCloseBanner()"
                            alt="close button"
                            src="/public/assets/images/btn-close-blue.png"
                          />
                        </div>
                      }
                    } @else {
                      <div
                        [class]="
                         isNotCollapsed && !isMobile
                           ? 'd-flex align-items-center justify-content-center'
                           : isMobile
                             ? ''
                             : ''
                       "
                        [style.margin-top.px]="!isNotCollapsed ? '0' : '10'"
                      >
                        @if (isNotCollapsed) {
                          <div>
                            <img
                              [src]="bannerData.logo_old"
                              [style.width.px]="isMobile ? '50' : '58'"
                              alt="Logo"
                              class="img"
                            />
                            <img
                              alt="Freccia a destra"
                              class="img"
                              src="/public/assets/images/arrow-right-banner.svg"
                            />
                            <img
                              [src]="bannerData.logo_new"
                              [style.width.px]="isMobile ? '148' : '204'"
                              alt="Logo"
                            />
                          </div>
                          <div
                            class="d-flex justify-content-end"
                            style="width: 39%"
                          >
                            <img
                              (click)="handleCloseBanner()"
                              alt="close button"
                              class="close-button-mb"
                              src="/public/assets/images/btn-close-blue.png"
                              width="31"
                            />
                          </div>
                        } @else {
                          @if (isMobile) {
                            <div class="logos-mobile">
                              <div>
                                <img
                                  [src]="bannerData.logo_old"
                                  alt="Logo"
                                  class="img"
                                  width="50"
                                />
                                <img
                                  alt="Freccia a destra"
                                  class="img"
                                  src="/public/assets/images/arrow-right-banner.svg"
                                  width="20px"
                                />
                                <img
                                  [src]="bannerData.logo_new"
                                  [style.width.px]="'148'"
                                  alt="Logo"
                                  class="img"
                                />
                              </div>
                              <img
                                (click)="handleCloseBanner()"
                                alt="close button"
                                class="close-button-mb"
                                src="/public/assets/images/btn-close-blue.png"
                              />
                            </div>
                          }
                        }
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
          @if (isSticky) {
            @if (!isMobile) {
              <!-- DESKTOP BANNER GRANDE-->
         <div
                class="banner-inner-no-img col-md-4 white"
                [class]="
                  isNotCollapsed
                    ? 'pd'
                    : !isSticky
                      ? 'col-md-5 col-6'
                      : 'col-md-4 col-6'
                "
              >
                <div
                  [class]="
                   isNotCollapsed
                     ? 'd-flex align-items-center justify-content-center aaa'
                     : ''
                 "
                  [style.margin-top.px]="!isNotCollapsed ? '0' : '10'"
                >
                  @if (isNotCollapsed) {
                    <img
                      [src]="bannerData.logo_old"
                      alt="Logo EA"
                      class="img"
                      width="68"
                    />
                    <img
                      alt="Freccia a destra"
                      class="img"
                      src="/public/assets/images/arrow-right-banner.svg"
                    />
                    <img
                      [src]="bannerData.logo_new"
                      alt="Logo"
                      width="204px"
                    />
                    <img
                      (click)="handleCloseBanner()"
                      alt="close button"
                      class="close_button"
                      src="/public/assets/images/btn-close-blue.png"
                    />
                  } @else {
                    <div nz-row class="custom-row">
                      <div
                        nz-col
                        nzMd="19"
                        [class]="!isNotCollapsed ? 'banner-piccolo' : ''"
                      >
                        <img
                          [src]="bannerData.logo_old"
                          [style.margin-right.px]="isMobile ? '0' : '15'"
                          alt="Logo"
                          width="58px"
                        />
                        <img
                          [style.margin-right.px]="isMobile ? '0' : '10'"
                          alt="Freccia a destra"
                          src="/public/assets/images/arrow-right-banner.svg"
                          width="20px"
                        />
                        <img
                          [src]="bannerData.logo_new"
                          alt="Logo"
                          width="131px"
                        />
                      </div>
                      <div
                        nz-col
                        nzMd="5"
                        class="d-flex justify-content-center align-items-center"
                      >
                        <a
                          [href]="bannerData.cta.collegamento"
                          class="banner-inner-btn"
                        >
                          {{ bannerData.cta.etichetta }}
                        </a>
                        <img
                          (click)="handleCloseBanner()"
                          alt="close button"
                          class="close"
                          src="/public/assets/images/btn-close-blue.png"
                        />
                      </div>
                    </div>
                  }
                </div>
              </div>
            } @else {
              <!-- MOBILE TITOLO, SOTTOTITOLO E SCOPRI DI PIU -->
              <div
                [class]="
                 isNotCollapsed
                   ? 'pd-m'
                   : isShowSticky
                     ? 'isSticky'
                     : ''
               "
                class="banner-inner-mb"
                nz-col
                [nzXs]="24"
              >
                @if (isNotCollapsed || isMobile) {
                  <p class="banner-inner-title">
                    {{ bannerData.title }}
                  </p>
                }
                <p
                  [class]="
                   !isNotCollapsed
                     ? 'banner-subtitle-mb'
                     : 'banner-inner-subtitle'
                 "
                  [innerHTML]="bannerData.description"
                  [style.font-size.px]="'18'"
                ></p>
                @if (isNotCollapsed || isMobile) {
                  <a
                    [href]="bannerData.cta.collegamento"
                    class="banner-inner-btn-coral"
                  >
                    {{ bannerData.cta.etichetta }}
                  </a>
                }
                @if (!isMobile) {
                  <img
                    (click)="handleCloseBanner()"
                    alt="close button"
                    class="close-button"
                    src="/public/assets/images/btn-close-blue.png"
                  />
                }
              </div>
            }
          }
        </div>
      </section>
    }
  }
}
